"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogActions = exports.cancelCall = exports.startCall = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const list_source_hook_1 = require("../../../utils/list-source-hook");
function startCall(url, id) {
    return abortable_fetch_1.abortableFetch(`${url}/${id}/start`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
    });
}
exports.startCall = startCall;
function cancelCall(url, id) {
    return abortable_fetch_1.abortableFetch(`${url}/${id}/cancel`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
    });
}
exports.cancelCall = cancelCall;
function useLogActions() {
    return list_source_hook_1.useStaticListSource([
        { id: 'ALWAYS', name: 'Vždy' },
        { id: 'ON_ERROR', name: 'Při chybě' },
        { id: 'NEVER', name: 'Nikdy' },
    ]);
}
exports.useLogActions = useLogActions;
//# sourceMappingURL=jobs-api.js.map